<template>
  <div>
    <div class="under-over">
      <div class="under-over__title">
        {{ listData.description }}
      </div>
      <div class="under-over__content">
        <div
            v-for="(value, name, index) in listData.outcomes"
            :key="index"
        >
          <div
              v-if="typeof value === 'object'"
              class="under-over__item focusable"
              :class="{active: value.isActive}"
              tabindex="1"
              @click="handleClickItem(value, listData)"
          >
            <div class="under-over__item-left under-over__item-common">{{ value.odds}}</div>
            <div class="under-over__item-right under-over__item-common">{{ value.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Object
    }
  },
  methods: {
    handleClickItem(value, name) {
      this.$emit('clickItem', { value, data: name })
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/ball/ball-chosen-under-over.scss"/>
